<!-- zoom banner 面试banner-->
<template>
  <div class="mentor-zoom-banner">
    <div class="mentor-zoom-banner-con">
      <h1>辅导开始时间：{{appDetail.menteeResultTimeStr}} （{{appDetail.menteeZone | zoneTitleMap}}）</h1>
      <a :href="appDetail.menteeZoom"
         target="_blank"
         v-if="appDetail.menteeZoom && (appDetail.statu==='INCOMPLETE' ||appDetail.statu==='TO_FEEDBACK')">开启Zoom</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-project-zoom-banner',
  props: ['appDetail'],
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {
  }
}
</script>
<style lang='less' scoped>
</style>
